import React from "react";
import Question from "./Question";

function QuestionList({ questions, onAnswerChange }) {
  return (
    <div className="questions-container">
      {questions.map((question, i) => (
        <Question
          key={question.id}
          question={question}
          index={i + 1}
          total={questions.length + 1}
          onChange={onAnswerChange}
        />
      ))}
    </div>
  );
}

export default QuestionList;
